import { FC } from 'react';
import { Box, GridItem, GridItemProps } from '@chakra-ui/react';

import webView from 'common/webView';

import { SIDEBAR_GRID_AREA } from '../../constants';

const Sidebar: FC<GridItemProps> = ({ children, ...props }) => {
  const { isInWebView } = webView;

  if (isInWebView) {
    return (
      <GridItem {...props} gridArea={SIDEBAR_GRID_AREA}>
        {/** Divider */}
        <Box backgroundColor="grey.300" height="space-6" marginY="space-32" />

        <Box paddingX="space-16">{children}</Box>
      </GridItem>
    );
  }

  return (
    <GridItem
      overflowY="auto"
      paddingTop="space-40"
      paddingX="space-16"
      {...props}
      borderLeft="1px solid"
      borderLeftColor="border"
      gridArea={SIDEBAR_GRID_AREA}
    >
      {children}
    </GridItem>
  );
};

export default Sidebar;
